import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Menu,
    MenuItem,
    FormControl,
    FormLabel,
    Select,
    FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Edit, Check, Add, Delete, ArrowDropDown } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLeadById, updateLead } from "../../redux/Slice/LeadSlice";
import AddFollowups from "../../components/lead/AddFollowups";
import { setLoading } from "../../redux/Slice/loaderSlice";
import ManageContactPersons from "../../components/lead/AddContact";
import AssignEmployeeToLead from "../../components/lead/AssignEmployeeToLead";
import AddDemoSchedule from "../../components/lead/AddDemoSchedule";
import { clearMessage } from "../../redux/Slice/message";
import { toast } from "sonner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { createCustomer } from "../../redux/Slice/customerSlice";
import dayjs from "dayjs";

const validationSchema = Yup.object({
    companyName: Yup.string().required("Company Name is required"),
    company_email: Yup.string().email("Enter a valid email address").required("Company Email is required"),
    industry: Yup.string().required("Industry is required"),
    website: Yup.string().url("Enter a valid URL"),
    bussinessSize: Yup.string().required("Business size is required"),
    leadStatus: Yup.string().required("Lead status is required"),
    leadSource: Yup.string().required("Lead source is required"),
    enquiryType: Yup.string().required("Enquiry type is required"),
    requirement: Yup.string().required("Requirement is required"),
});

const LeadDetails = () => {
    const params = useParams();
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { profile } = useSelector((state) => state.auth);

    const [data, setData] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openMenu, setOpenMenu] = useState(false);
    const [openDialog, setOpenDialog] = useState(false); 
    const [isEditingCompany, setIsEditingCompany] = useState(false);
    const [isEditingLead, setIsEditingLead] = useState(false);
    const [connotes, setConNotes] = useState(null);
    const [reason, setReason] = useState('');
    const [actionType, setActionType] = useState('');
   const message = useSelector((state) => state.message);
   const { leadDetails} = useSelector((state) => state.leads);
//    console.log("leadDetails:",leadDetails);
   

    const fetchLeadByid = async() => {
        await dispatch(getLeadById(params.id)).then((response) => {
            // setData(response.payload);
        });
    }
    useEffect(()=>{
        if(leadDetails){
            setData(leadDetails) 
        }
    },[leadDetails]);

    useEffect(() => {
        dispatch(setLoading(true))
        fetchLeadByid()
        .then(()=> dispatch(setLoading(false)))
        .catch(()=> dispatch(setLoading(false)))
       
    }, []);

    useEffect(() => {
        if (message?.message) {
          toast(message.message)
          dispatch(clearMessage())
        }
      }, [message, dispatch])

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenMenu(true);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setOpenMenu(false);
    };

    const handleMenuItemClick = (action) => {
     setActionType(action);
     setOpenDialog(true);
     setOpenMenu(false);
    };

   const handleDialogClose = () => {
     setOpenDialog(false);
     setReason("");
     setConNotes("");
   };

    
  const handleConfirmAction = () => {
    if (actionType === "Convert to Customer") {
      handleConfirmConvert();
      console.log("Convert to Customer:", connotes);
    } else if (actionType === "Lost Drop") {
        handleLost();
      console.log("Lost Drop Reason:", reason);
    }
    setOpenDialog(false);
  };

  const handleConfirmConvert = async () => {
    const formData = {
        _id: null,
        ...data,
        customer_type: "Converted from Lead",
        lead_Conversion_details: {
            lead_id: params.id,
            conversion_date: dayjs(),
            converted_by: profile?.name,
            conversion_notes: connotes
        }
    };

    dispatch(setLoading(true));

    try {
        const response = await dispatch(createCustomer(formData)).unwrap();

        if (response) {
            const formData1 = {
                leadStatus: "Convert to Customer"
            };

            await dispatch(updateLead({ l_id: params.id, formData: formData1 })).unwrap();
        }

        navigate("/customers");
        setOpenDialog(false);
    } catch (error) {
        console.error(error);
        toast.error(error.message || "Failed to convert lead to customer");
    } finally {
        dispatch(setLoading(false));
    }
};


    const handleLost = () => {
        dispatch(setLoading(true));
        const formData1 = {
            leadStatus : 'Lost Drop',
            lostDropReason: reason
        }
        dispatch(updateLead({l_id: params.id, formData: {...formData1}})) 
        dispatch(setLoading(false));
        navigate("/leads"); 
        setOpenDialog(false);  
    }


    return (
        <Box className="content" p={0}>
            <Grid container marginBottom={2} spacing={2} alignItems="center" justifyContent="space-between">
              <Grid item>
                  <Typography variant="h4" gutterBottom>
                      Lead From {data?.companyName}
                  </Typography>
              </Grid>

                <Grid item>
                    <Button size="large" variant="outlined" onClick={handleMenuClick} sx={{ display: 'flex', alignItems: 'center', }}>
                    {data?.leadStatus} <ArrowDropDown />
                    </Button>
                    {data?.leadStatus === "New" && 
                    <Menu anchorEl={anchorEl} open={openMenu} onClose={handleMenuClose}>
                        <MenuItem onClick={() => handleMenuItemClick('Convert to Customer')}>Convert to Customer</MenuItem>
                        <MenuItem onClick={() => handleMenuItemClick('Lost Drop')}>Lost Drop</MenuItem>
                    </Menu>
                    }
                </Grid>
            </Grid>


            <Grid container spacing={3} sx={{ alignItems: 'stretch' }}>
            <Formik
    initialValues={{
        companyName: leadDetails?.companyName || "",
        company_email: leadDetails?.company_email || "",
        industry: leadDetails?.industry || "",
        website: leadDetails?.website || "",
        bussinessSize: leadDetails?.bussinessSize || "",
        leadStatus: leadDetails?.leadStatus || "",
        leadSource: leadDetails?.leadSource || "",
        enquiryType: leadDetails?.enquiryType || "",
        requirement: leadDetails?.requirement || "",
    }}
    validationSchema={validationSchema}
    onSubmit={async(values) => {
        console.log("Form submitted", values);
         try {
            dispatch(setLoading(true));
            const leadData = { formData:values, l_id: leadDetails?._id };
            await dispatch(updateLead( leadData));
         
        } catch (error) {
            console.error('Error submitting lead:', error);
        } finally {
            dispatch(setLoading(false));
        }
        // toast.success("Details saved successfully");
    }}
    enableReinitialize
>
    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
             <Grid container spacing={3}>
                {/* Company Details */}
                <Grid item size={{xs:12, md:6}}>
                    <Paper elevation={3} sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
                        <Box flexDirection="row" justifyContent="space-between" alignItems="center" display="flex" sx={{ mb: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                Company Details
                            </Typography>
                            <IconButton onClick={() => {
                                setIsEditingCompany(!isEditingCompany)
                                if (isEditingCompany) handleSubmit();
                            }}>
                                {isEditingCompany ? <Check color="success" /> : <Edit />}
                            </IconButton>
                        </Box>

                        <FormControl fullWidth>
                            <FormLabel>Company Name *</FormLabel>
                            <TextField
                                name="companyName"
                                placeholder="Company Name"
                                variant="outlined"
                                value={values.companyName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.companyName && Boolean(errors.companyName)}
                                helperText={touched.companyName && errors.companyName}
                                disabled={!isEditingCompany}
                            />
                        </FormControl>

                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <FormLabel>Company Email*</FormLabel>
                            <TextField
                                name="company_email"
                                placeholder="Company Email"
                                variant="outlined"
                                value={values.company_email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.company_email && Boolean(errors.company_email)}
                                helperText={touched.company_email && errors.company_email}
                                disabled={!isEditingCompany}
                            />
                        </FormControl>

                        {/* Industry Select */}
                        <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel>Industry *</FormLabel>
                        <Select
                            name="industry"
                            value={values.industry}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={!isEditingCompany}
                        >
                            <MenuItem value="Construction">Construction</MenuItem>
                            <MenuItem value="IT">IT</MenuItem>
                            <MenuItem value="Finance">Finance</MenuItem>
                            <MenuItem value="Healthcare">Healthcare</MenuItem>
                            <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        {touched.industry && errors.industry && (
                            <FormHelperText error>{errors.industry}</FormHelperText>
                        )}
                    </FormControl>

                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <FormLabel>Website *</FormLabel>
                            <TextField
                                name="website"
                                placeholder="Website"
                                variant="outlined"
                                value={values.website}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.website && Boolean(errors.website)}
                                helperText={touched.website && errors.website}
                                disabled={!isEditingCompany}
                            />
                        </FormControl>

                         {/* Business Size Select */}
                         <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel>Business Size *</FormLabel>
                        <Select
                            name="bussinessSize"
                            value={values.bussinessSize}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={!isEditingCompany}
                        >
                            <MenuItem value="Small">Small</MenuItem>
                            <MenuItem value="Medium">Medium</MenuItem>
                            <MenuItem value="Large">Large</MenuItem>
                        </Select>
                        {touched.bussinessSize && errors.bussinessSize && (
                            <FormHelperText error>{errors.bussinessSize}</FormHelperText>
                        )}
                    </FormControl>
                    </Paper>
                </Grid>

                {/* Lead Details */}
                <Grid item size={{xs:12, md:6}}>
                    <Paper elevation={3} sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
                        <Box flexDirection="row" justifyContent="space-between" alignItems="center" display="flex" sx={{ mb: 2 }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                Lead Details
                            </Typography>
                            <IconButton onClick={() => {
                                setIsEditingLead(!isEditingLead)
                                if (isEditingLead) handleSubmit();
                                }}>
                                {isEditingLead ? <Check color="success" /> : <Edit />}
                            </IconButton>
                        </Box>

                        {/* Lead Status Select */}
                        <FormControl fullWidth  >
                        <FormLabel>Lead Status *</FormLabel>
                        <TextField
                                name="leadStatus"
                                placeholder="Lead Status"
                                variant="outlined"
                                value={values.leadStatus}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.leadStatus && Boolean(errors.leadStatus)}
                                helperText={touched.leadStatus && errors.leadStatus}
                                disabled={!isEditingLead}
                                InputProps={{
                                    readOnly: true
                                }}
                            />
                    </FormControl>

                    {/* Lead Source Select */}
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel>Lead Source *</FormLabel>
                        <Select
                            name="leadSource"
                            value={values.leadSource}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={!isEditingLead}
                        >
                            <MenuItem value="Referral">Referral</MenuItem>
                            <MenuItem value="Website">Website</MenuItem>
                            <MenuItem value="Advertisement">Advertisement</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        {touched.leadSource && errors.leadSource && (
                            <FormHelperText error>{errors.leadSource}</FormHelperText>
                        )}
                    </FormControl>

                    {/* Enquiry Type Select */}
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel>Enquiry Type *</FormLabel>
                        <Select
                            name="enquiryType"
                            value={values?.enquiryType}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={!isEditingLead}
                        >
                            <MenuItem value="Hot">Hot</MenuItem>
                            <MenuItem value="Warm">Warm</MenuItem>
                            <MenuItem value="Cold">Cold</MenuItem>
                        </Select>
                        {touched.enquiryType && errors.enquiryType && (
                            <FormHelperText error>{errors.enquiryType}</FormHelperText>
                        )}
                    </FormControl>

                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <FormLabel>Requirement *</FormLabel>
                            <TextField
                                name="requirement"
                                placeholder="Requirement"
                                variant="outlined"
                                value={values.requirement}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.requirement && Boolean(errors.requirement)}
                                helperText={touched.requirement && errors.requirement}
                                disabled={!isEditingLead}
                            />
                        </FormControl>
                    </Paper>
                </Grid>
            </Grid>
        </form>
    )}
</Formik>


    <AssignEmployeeToLead data={data} setData={setData} />
    <ManageContactPersons data={data} setData={setData} />
    <AddFollowups data={data} setData={setData} />
    <AddDemoSchedule data={data} setData={setData} />
</Grid>



          {/* Popup Dialog for Convert to Customer */}
          <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>{actionType}</DialogTitle>
        <DialogContent>
          <Typography>
            {actionType === "Convert to Customer" ? "Would you like to proceed with converting this lead into a customer?": "Could you kindly provide the reason for considering this as the Lost Drop?"}
          </Typography>
          {actionType === "Lost Drop" ? (
            <TextField
              value={reason}
               placeholder="Reason"
              variant="outlined"
              onChange={(e) => setReason(e.target.value)}
              fullWidth
              multiline
              sx={{ mt: 2 }}
              InputProps={{
                style: {height: "100px",alignItems: "flex-start",resize: "none",overflowY: "auto",},
              }}
            />
          ) : (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <TextField
                name="conversionNotes"
                value={connotes}
                onChange={(e) => setConNotes(e.target.value)}
                placeholder="Conversion Notes"
                variant="outlined"
                fullWidth
                multiline
                InputProps={{
                  style: {height: "100px",alignItems: "flex-start",resize: "none",overflowY: "auto",},
                }}
              />
            </FormControl>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmAction} variant="contained" color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
            <Grid />

            {/* Add Contact Person Dialog */}
            
        </Box>
    );
};

export default LeadDetails;
